import request from '@/utils/request'

// var http = process.env.BASE_API;
// var big_data = "https://bigdata.q12301.com"
//客源地热力图
export function txHeatMapApi(query) {
  return new Promise((resolve, reject)=>{
    var returnData = request({
      url: 'https://rml-ticket-api.q12301.com/service/get-today-big-data-four-api/',
      method: 'get',
      params: query
    })
    if(true){
      resolve(returnData);
    }
  })
}

export function getUsrPortraitApi(query) {
  return new Promise((resolve, reject)=>{
    var returnData = request({
      url: 'https://rml-ticket-api.q12301.com/service/get-user-portrait-api/',
      method: 'get',
      params: query
    })
    if(true){
      resolve(returnData);
    }
  })
}

//客源地热力图
export function hlTopData(query) {
  return new Promise((resolve, reject)=>{
    var returnData = request({
      url: 'https://rml-ticket-api.q12301.com/service/get-today-big-data-one-api/',
      method: 'get',
      params: query
    })
    if(true){
      resolve(returnData);
    }
  })
}

export function hlLeftData(query) {
  return new Promise((resolve, reject)=>{
    var returnData = request({
      url: 'https://rml-ticket-api.q12301.com/service/get-today-big-data-two-api/',
      method: 'get',
      params: query
    })
    if(true){
      resolve(returnData);
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/SceneTourists.js